import React, { FC } from 'react'

import { cx } from '@linaria/core'
import { styled } from '@linaria/react'

import { ComplaintsType } from 'api/complaints/complaintsApi'
import { VoidHandler, WithClassName } from 'common/types'
import { ComplainList } from 'components/block/Complaints/ComplainList'
import { SharingType } from 'components/block/SharingContent/SharingContent.constant'
import { SharingContent } from 'components/block/SharingContent/SharingContentIndex'
import { StareShareComplaint } from 'components/block/TooltipShareComplaints/StartShareComplaint'
import {
  BottomSheet,
  useBottomSheet,
} from 'components/designSystem/BottomSheet/BottomSheet'
import { Meatballs } from 'components/designSystem/Meatballs/Meatballs'
import { breakpoints } from 'components/designSystem/shared/breakpoints'
import { Slot } from 'components/designSystem/Slot/Slot'

export const Mobile: FC<
  WithClassName & { profileId: number; onCallback?: VoidHandler }
> = ({ className, profileId, onCallback }) => {
  const startSheet = useBottomSheet()
  const complainsSheet = useBottomSheet()
  const shareSheet = useBottomSheet()

  const handleCallbackComplaintSend = () => {
    onCallback?.()
    complainsSheet.close()
  }

  return (
    <Parent className={cx(className)} data-name="share-complaint-mobile">
      <Meatballs onClick={startSheet.open} />
      <BottomSheet ref={startSheet.ref}>
        <StareShareComplaint
          onComplainsClick={() => {
            startSheet.close(), complainsSheet.open()
          }}
          onShareClick={() => {
            startSheet.close()
            shareSheet.open()
          }}
        />
      </BottomSheet>
      <BottomSheet ref={shareSheet.ref}>
        <Slot type="vertical">
          <SharingContent
            type={SharingType.profile}
            contentId={profileId}
            profileId={profileId}
            callbackHandler={shareSheet.close}
            hasNewDesign={true}
          />
        </Slot>
      </BottomSheet>
      <BottomSheet ref={complainsSheet.ref}>
        <ComplainList
          violatorId={profileId}
          complaintListType={ComplaintsType.profile}
          complaintType={ComplaintsType.profile}
          entityId={profileId}
          actionAfterComplainSend={handleCallbackComplaintSend}
          showRedesignComplaints={true}
        />
      </BottomSheet>
    </Parent>
  )
}

const Parent = styled.div`
  display: block;
  color: var(--foreground-default);

  @media screen and (min-width: ${breakpoints.mobile + 1}px) {
    display: none;
  }
`
